/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./pages/Login/Login";
import ProtectedRoute from "./components/ProtectedRoute";
import Settings from "./pages/Settings/Settings";
import Dashboard from "./pages/Dashboard/Dashboard";
import DashboardHome from "./pages/Dashboard/DashboardHome";
import Profile from "./pages/Profile/Profile";
import ForgotPassword from "./pages/ForgotPassword/ForgotPassword";
import CreateProject from "./pages/CreateProject";
import PartnersPage from "./pages/Partners/PartnersPage";
import AdminRoute from "./components/AdminRoute";
import DataTableDemo from "./pages/Partners/PartnersTable";
import { useSelector } from "react-redux";
import { RootState } from "./app/store";
import { connectSocket, sendMessage } from "./websockets/socket";
import { fetchNotifications } from "./features/auth/notificationSlice";
import { useAppDispatch, useAppSelector } from "./hooks/reduxHooks";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"
import Notifications from "./components/notifications/Notifications";
import PartnerRoutes from "./components/notifications/PartnerRoute";

function App() {

const {partnerId} = useSelector((state:RootState)=> state.auth)
const dispatch = useAppDispatch()
  const {notifications} = useAppSelector((state)=> state.notifications);


  useEffect(()=>{
    if (!partnerId) return;
  connectSocket(()=>{
    sendMessage({
      type:"auth",
      data:{
        userId:partnerId
      }
    })
  })
},[])
 const fetchNotify = async()=>{
    if(partnerId){

      dispatch(fetchNotifications({userId:partnerId,search:""})) 
    }
  } 

  useEffect(()=>{
    fetchNotify()
  },[partnerId])

  return (
    <>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />

        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        >
          <Route index element={<DashboardHome />} />
          <Route path="profile" element={<Profile />} />
          <Route path="settings" element={<Settings />} />
          <Route path="create-project" element={<CreateProject />} />
          <Route path="notifications" element={
            <PartnerRoutes>

            <Notifications />
            </PartnerRoutes>
            } />
          <Route
            path="partners"
            element={
              <AdminRoute>
                {/* <PartnersPage /> */}
                <DataTableDemo/>
              </AdminRoute>
            }
          />
        </Route>
        {/* <Route path="notifications"
        element={
          <ProtectedRoute>
            <Notifications/>
          // </ProtectedRoute>
        }
        /> */}

       

        <Route path="*" element={<Login />} />
      </Routes>
    </BrowserRouter>
     <ToastContainer position="top-right" autoClose={4000} /> 
    
            </>
  );
}

export default App;
